import moment from 'moment'
import time from '../../../server/utils/time.js'
import dbCodes from '../../../server/dbCodes.js'
import {Reseller} from '../resellers/resellers.types.js'
import {Order} from './orders.types.js'

type NewOrderSettingsParams = {
    selectedDate?: string
    defaultAddresses?: Reseller['settings']['orders']['defaultAddresses']
    forcePickupAndDeliverAddresses?: boolean
}

export default (reseller?: Reseller, params?: NewOrderSettingsParams): Order => {
    const {selectedDate, forcePickupAndDeliverAddresses} = params || {}
    let {defaultAddresses} = params || {}
    const orderAddresses: Order['addresses'] = []
    defaultAddresses = defaultAddresses || reseller?.settings?.orders?.defaultAddresses || 'deliver'

    const baseAddress: Order['addresses'][number] = {
        type: 'pickup',
        name: '',
        attention: '',
        street: '',
        nr: '',
        addition: '',
        street2: '',
        postalCode: '',
        city: '',
        country: 'NL',
        isBusiness: false,
        instructions: '',
        email: '',
        phone: '',
        startTime: reseller?.settings?.account?.openingHours[moment().format('dddd').toLowerCase()] ?
            reseller.settings.account.openingHours[moment().format('dddd').toLowerCase()].from :
            '00:00',
        endTime: reseller?.settings?.account?.openingHours[moment().format('dddd').toLowerCase()] && reseller.settings.account.openingHours[moment().format('dddd').toLowerCase()].till > moment().format('HH:mm') ?
            reseller.settings.account.openingHours[moment().format('dddd').toLowerCase()].till :
            '23:59'
    }
    if (forcePickupAndDeliverAddresses || !reseller || defaultAddresses === 'pickupAndDeliver') {
        orderAddresses.push(
            baseAddress,
            {
                ...baseAddress,
                type: 'delivery',
                gpsRequired: false,
                signatureRequired: false,
                signatureNeighbors: false,
                statedAddressOnly: false,
                nameRequired: false,
                scanRequired: false,
                imageRequired: false,
                mailboxDelivery: false,
                refrigerated: false,
                minimumAge: false,
                idCheck: false
            }
        )
    } else if (defaultAddresses === 'deliver') {
        orderAddresses.push({
            ...baseAddress,
            type: 'delivery',
            gpsRequired: false,
            signatureRequired: false,
            signatureNeighbors: false,
            statedAddressOnly: false,
            nameRequired: false,
            scanRequired: false,
            imageRequired: false,
            mailboxDelivery: false,
            refrigerated: false,
            minimumAge: false,
            idCheck: false
        })
    } else if (defaultAddresses === 'pickup') {
        orderAddresses.push(baseAddress)
    }

    if (reseller) {
        orderAddresses.forEach((address) => {
            if (address.type === 'pickup') {
                const pickupOptions = reseller.settings.orders.defaultPickupOptions

                for (const option of pickupOptions) {
                    if (option in dbCodes.pickupOptions) {
                        address[option] = true
                    } else {
                        address.customOptions = address.customOptions || []
                        address.customOptions.push(option)
                    }
                }
            }

            if (address.type === 'delivery') {
                const deliveryOptions = reseller.settings.orders.defaultDeliveryOptions

                for (const option of deliveryOptions) {
                    if (option in dbCodes.pickupAndDeliveryOptions) {
                        if (option === 'minimumAge +16') {
                            address.minimumAge = 16
                        } else if (option === 'minimumAge +18') {
                            address.minimumAge = 18
                        } else if (option === 'minimumAge +21') {
                            address.minimumAge = 21
                        } else {
                            address[option] = true
                        }
                    } else {
                        address.customOptions = address.customOptions || []
                        address.customOptions.push(option)
                    }
                }
            }
        })
    }

    const order: Order = {
        handledBy: '',
        carrierId: '',

        date: reseller?.settings?.orders?.defaultDate === 'selectedDate' && selectedDate ? selectedDate : time.today(),
        routeId: '',
        customer: '',
        contact: '',
        email: '',
        phone: '',

        customerAddress: {
            name: '',
            attention: '',
            street: '',
            nr: '',
            addition: '',
            street2: '',
            postalCode: '',
            city: '',
            country: 'NL',
            isBusiness: false,
            instructions: '',
            email: '',
            phone: ''
        },
        addresses: orderAddresses,
        colli: [],
        addressOrder: 'fixed',

        nrOfDeliveries: 0,
        autoRetour: false,
        nrOfDaysBeforeRetour: 7,
        retourAddress: {
            type: 'delivery',
            name: '',
            attention: '',
            street: '',
            nr: '',
            addition: '',
            street2: '',
            postalCode: '',
            city: '',
            country: 'NL',
            isBusiness: false,
            instructions: '',
            email: '',
            phone: '',
            startTime: reseller?.settings?.account?.openingHours[moment().format('dddd').toLowerCase()] ?
                reseller.settings.account.openingHours[moment().format('dddd').toLowerCase()].from :
                '00:00',
            endTime: reseller?.settings?.account?.openingHours[moment().format('dddd').toLowerCase()] ?
                reseller.settings.account.openingHours[moment().format('dddd').toLowerCase()].till :
                '23:59',
            gpsRequired: false,
            signatureRequired: false,
            signatureNeighbors: false,
            statedAddressOnly: false,
            nameRequired: false,
            scanRequired: false,
            imageRequired: false,
            mailboxDelivery: false,
            refrigerated: false,
            minimumAge: false,
            idCheck: false
        },

        monitorTemperature: false,
        sensorId: '',

        priceTableId: '',
        price: '0,00',
        feeIds: [],
        fees: [],
        invoiceDate: time.today(),
        invoicedAmount: '',
        dontInvoice: false,
        checked: false,
        invoiced: false,
        reference: '',

        notes: '',

        history: [],
        status: dbCodes.status.gereed(),
        trackTrace: '',
        noTrackTrace: false,
        noEmailNotifications: false,

        additionalProps: {}

    }

    return JSON.parse(JSON.stringify(order))
}
